import { useDashboardConfig } from '@/hooks/useDashboardConfig';

const MAX_FAVORITES = 10; // Fallback value of max favorites
export const COMPANY_ITEM_PER_PAGE = 4; // Number of company per page on Siren search
export const COMPANY_MEMBERS_PER_PAGE = 50; // Number of company members (children) per page
export const KYC_DOCUMENTS_PER_PAGE = 10;
export const itemsMaxPerPage = 50;
export const MAX_VISIBLE_RENDERED_VALUES = 3; // Number of max visible values rendred on a filter

export const minimumDate = new Date(new Date().getFullYear() - 100, new Date().getMonth(), new Date().getDate());

export function useDashboardConstants() {
  const config = useDashboardConfig();

  const maxFavorites = config?.settings?.users?.favorites?.['wallet'] || MAX_FAVORITES;

  const instantTransfer = config?.settings?.payouts?.instantTransfer || undefined;

  return { maxFavorites, instantTransfer };
}
